<template>
  <div>
    <v-text-field label="Discount Amount" type="number" :value="amount" prefix="₱" outlined dense hide-details
      @input="amountChange" />
  </div>
</template>

<script>
export default {
  name: 'FixDisc',
  props: {
    amount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    /**
     * @param {InputEvent} e
     */
    amountChange(val) {
      this.$emit('update:amount', val)
    },
  },
}
</script>